export const initLandingpage = () => {
	const main = document.querySelector(`main[page-type="landing"]`);
	if(!main){
		return;
	}
	document.body.classList.add("landing-page");
};
initLandingpage();
